import * as React from 'react'
import classnames from 'classnames'

interface IFloatingFormProps {
  children: React.ReactNode
  isSubmitting?: boolean
  fullHeight?: boolean
}
const FloatingForm = (props: IFloatingFormProps) => {
  const { children, isSubmitting, fullHeight } = props
  return (
    <div className={classnames('form-background', fullHeight ? 'full-height' : '')}>
      <div
        className={classnames('form-modal', fullHeight ? 'full-height' : '')}
        style={{
          pointerEvents: isSubmitting ? 'none' : 'auto',
          opacity: isSubmitting ? 0.4 : 1.0
        }}
      >
        <div className='form-modal-body'>{children}</div>
      </div>
    </div>
  )
}

export default FloatingForm



// WEBPACK FOOTER //
// ./src/components/ui/form/FloatingForm.tsx